
export enum HeaderModeEnum {
  DEFAULT = 'default',
  FIXED = 'fixed',
  HIDDEN = 'hidden',
}

export interface HeaderInitInterface {
  mode?: HeaderModeEnum;
}
